<template>
  <div v-if="eligibleForDiscountPromotion" class="check-card-promo-eligibility">
    <div class="loader-container" v-if="loadingBenefit">
      <tiny-loader :variant="'secondary'" />
    </div>
    <div v-else>
      <div class="error" v-if="eligibilityError">הכרטיס שהוכנס לא תקין</div>
      <div class="eligible" v-else-if="eligibleForDiscountBenefit && !loadingToken">מצוין, הכרטיס כלול בהטבת דיסקונט!</div>
      <div class="not-eligible" v-else-if="eligibleForDiscountBenefit === false && !loadingToken">הכרטיס לא כלול בהטבה, אפשר לנסות אחר</div>
      <div class="is-eligible" v-else v-on:click="checkAndCreateDiscountBenefit">האם הכרטיס שלי כלול בהטבה?</div>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'CheckCardPromoEligibility',
  components: {
    TinyLoader: BaseUI.TinyLoader,
  },
  props: {
    createBenefit: {
      type: Function,
    },
  },
  computed: {
    ...mapState('subscription', ['loadingBenefit', 'loadingToken', 'eligibleForDiscountBenefit', 'eligibilityError']),
    ...mapState('discountPromotion', ['eligibleForDiscountPromotion']),
  },
  methods: {
    ...mapActions('subscription', ['checkDiscountBenefitEligibility']),
    async checkAndCreateDiscountBenefit() {
      await this.checkDiscountBenefitEligibility();
      await this.createBenefit();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';

  .check-card-promo-eligibility {
    text-align: center;
    font-size: 16px;
    font-weight: bold;

    .loader-container {
      display: flex;
      width: 100%;
      justify-content: center;
    }

    .is-eligible {
      color: $riseup_light_blue;
      text-decoration: underline;
      cursor: pointer;
    }

    .eligible {
      color: $discount_green;
    }

    .not-eligible, .error {
      color: $riseup_coral
    }

  }
</style>
